import { Component, html, LitElement } from '@rxdi/lit-html';
import { RouteParams } from '@rxdi/router';

/**
 * @customElement magic-link-success
 */
@Component({
  selector: 'magic-link-success',
  template(this: SuccessMagicLinkComponent) {
    return html`
      <div style=" margin-top: 140px;">
        <div style="text-align: center;">
          <p>Magic link was send to ${this.params.email}</p>
          <p>Please check your email</p>
        </div>
      </div>
    `;
  },
})
export class SuccessMagicLinkComponent extends LitElement {
  @RouteParams() params: { email: string };
}
